const EPOCH_OFFSET = BigInt(3 * 24 * 60 * 60); // 3 days in seconds
const EPOCH = BigInt(7 * 24 * 60 * 60); // 7 days in seconds

export function getNextEpoch(): number {
    return getCurrentEpoch() + 1;
}

export function getCurrentEpoch(): number {
    const timestamp = BigInt(Date.now()) / 1000n;
    return Number(epoch(timestamp));
}

export function epoch(timestamp: bigint): bigint {
    return (timestamp - EPOCH_OFFSET) / EPOCH;
}

export function getEpochTimestamp(epoch: number): number {
    return Number(BigInt(epoch) * EPOCH + EPOCH_OFFSET) * 1000;
}

export function truncateAPYDecimals(value: string | bigint | number, _decimals = 2): string {
    const valueStr = value.toString();
    const [whole, decimal] = valueStr.split(".");

    if (!decimal) {
        return whole;
    }

    const formattedDecimal = decimal.slice(0, _decimals);
    return `${whole}.${formattedDecimal}`.replace(/\.?0+$/, "");
}

const POINTS_PROGRAM_START_BLOCK = 22564420;
const BLOCK_PER_POINTS_EPOCH = 50400;

export function getPointsEpochBlockRange(epoch: number): { start: number; end: number } {
    const start = POINTS_PROGRAM_START_BLOCK + epoch * BLOCK_PER_POINTS_EPOCH;
    const end = start + BLOCK_PER_POINTS_EPOCH - 1;
    return { start, end };
}

export function getCurrentPointsEpoch(currentBlockNumber: number): number {
    return (currentBlockNumber - POINTS_PROGRAM_START_BLOCK) / BLOCK_PER_POINTS_EPOCH;
}
